<template>
  <div class="m-contact">
    <section class="m-contact-hero">
      <img class="m-contact-hero__bg" src="https://qiniu.shunmingelectronic.com/guanwang/product/lianxiwomen.jpg"
        alt="联系我们" />
      <div class="m-contact-hero__overlay"></div>
      <div class="m-contact-hero__content">
        <span class="km-eyebrow">CONTACT US</span>
        <h1 class="m-contact-hero__title">联系我们</h1>
      </div>
    </section>

    <section class="m-section">
      <div class="km-container">
        <div class="m-stack">
          <div class="km-card m-info">
            <span class="m-info__label">公司名称</span>
            <span class="m-info__value">河南舜铭电子信息科技有限公司</span>
          </div>
          <div class="km-card m-info">
            <span class="m-info__label">公司地址</span>
            <span class="m-info__value">中国（河南）自由贸易试验区洛阳片区（高新）丰华路1号803-3</span>
          </div>
          <div class="km-card m-info">
            <span class="m-info__label">联系电话</span>
            <span class="m-info__value">+86 16662992205<br>0379-63220552</span>
          </div>
          <div class="km-card m-info">
            <span class="m-info__label">邮箱</span>
            <span class="m-info__value">bright_xu@sina.cn</span>
          </div>

          <div class="km-card m-qr">
            <span class="m-qr__label">微信扫码 · 与我们对话</span>
            <div class="m-qr__img"><img src="../../assets/fswxh.png" alt="微信二维码" /></div>
            <span class="m-qr__hint">扫描上方二维码添加微信</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MobileContactView'
}
</script>

<style scoped>
.m-contact {
  background: var(--bg);
}

.m-contact-hero {
  position: relative;
  min-height: 260px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}

.m-contact-hero__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.m-contact-hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.72) 70%, var(--bg) 100%);
}

.m-contact-hero__content {
  position: relative;
  z-index: 1;
  padding: 0 20px 30px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.m-contact-hero__title {
  font-family: var(--font-display);
  font-size: 34px;
  font-weight: 700;
  margin: 0;
  color: #fff;
}

.m-contact-hero__content .km-eyebrow {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.10);
}

.m-section {
  padding: 48px 0 64px;
}

.m-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.m-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 22px 22px;
  text-align: left;
}

.m-info__label {
  font-family: var(--font-display);
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--accent);
}

.m-info__value {
  color: var(--text);
  font-size: 16px;
  line-height: 1.7;
}

.m-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px;
  text-align: center;
}

.m-qr__label {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 16px;
}

.m-qr__img {
  width: 200px;
  max-width: 80%;
  background: #fff;
  border-radius: var(--radius);
  padding: 12px;
}

.m-qr__img img {
  width: 100%;
  display: block;
}

.m-qr__hint {
  color: var(--text-soft);
  font-size: 13px;
}
</style>
